import { BaseService } from './base.service'

export class UsersService extends BaseService {
  static get entity () {
    return 'users'
  }

  static getCurrent () {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('Dashboard/CustomerProfile')
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.error : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static changePassword (oldPassword, password) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post('Authenticate/ChangePassword', {
        username: localStorage.getItem('username'),
        oldpassword: oldPassword,
        newpassword: password
      })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static updateProfile (data) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post('Account/UpdateInformation', data)
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static async resendOTPNewPhone (newPhoneNumber) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post('Account/ResendOTPNewPhone', { NewPhoneNumber: newPhoneNumber })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static async confirmOtpNewPhone (otp) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post('Account/ConfirmOTPNewPhone', { OTP: otp })
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getListCity () {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('Account/GetListCity', { params: { pageSize: 999999 } })
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getListDistrict (cityCD) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get(`Account/getListDistrict/${cityCD}`, { params: { pageSize: 999999 } })
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getListWard (districtCD) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get(`Account/getListWard/${districtCD}`, { params: { pageSize: 999999 } })
        .then(response => resolve(this.responseWrapper(response, response.data.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static getHistoryModify (parameters = {}) {
    const params = {
      ...parameters
    }
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).get('Account/GetHistoryModify', { params })
        .then(response => {
          const data = {
            content: response.data.data,
            total: response.data.meta.totalRow
          }
          resolve(this.responseWrapper(response, data))
        })
        .catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }

  static async updateViaEmail (status) {
    return new Promise((resolve, reject) => {
      return this.request({ auth: true }).post('Dashboard/UpdateViaEmail/' + status, {})
        .then(response => resolve(this.responseWrapper(response, response.data)))
        .catch(error => {
          const message = error.response.data ? error.response.data.Message : error.response.statusText
          reject(this.errorWrapper(error, message))
        })
    })
  }
}
